export default __webpack_public_path__ + "static/media/help.32fd2b6a.svg";